module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('h2', [_vm._v("Баланс")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('span', [_vm._v("ЛС " + _vm._s(_vm.Account.num) + "  ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'История счета'
      },
      "text-right": ""
    }
  }, [_vm._v("История операций")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "elevation-1 my-2"
  }, [_c('v-layout', {
    attrs: {
      "justify-start": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('div', {
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v(_vm._s(_vm.Account.sum_balance) + " р.")]), _vm._v(" "), _c('div', {
    staticClass: "labelsum"
  }, [_vm._v("свободно")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('div', {
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v(_vm._s(_vm.Account.sum_invested) + " р.")]), _vm._v(" "), _c('div', {
    staticClass: "labelsum"
  }, [_vm._v("инвестировано")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('div', {
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v(_vm._s(_vm.Account.sum_locked) + " р.")]), _vm._v(" "), _c('div', {
    staticClass: "labelsum"
  }, [_vm._v("резерв")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-space-around": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "outline": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.fund(_vm.Account.id)
      }
    }
  }, [_vm._v("Пополнить счет")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "outline": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.withdraw(_vm.Account.id)
      }
    }
  }, [_vm._v("Вывести деньги")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7403d1e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/BalanceBox.vue
// module id = 467
// module chunks = 1